export const transformChecklist = (data) => {
  const {
    name,
    ...rest
  } = data;

  return {
    ...rest,
    title: name,
  };
};

export const transformGqlDataToRecord = (data) => {
  const {
    id,
    orgId,
    status,
    dateInquiry,
    // contactName,
    contactFirstName,
    contactLastName,
    // profileImage,
    // contactEmail,
    // contactNumber,
    contactId,
    eventDate,
    // eventLocation,
    startTime,
    endTime,
    allDay,
    // serviceType,
    // leadSource,
    estimateBudget,
    // estimateBudgetFormatted,
    lastContactedDate,
    leadCustomStatusId,
    lostReasonId,
    contactCompanyName,
    orgLeadContactId,
    isDeleted,
    // organizationMemberAssignments,
    party,
    projectName,
    venueName,
    createdAt,
  } = data;

  // Only emit fields this GraphQL projection actually carries. Placeholder values
  // (null / '' / 0) for unselected fields would overwrite the fuller record the REST
  // fetch puts in the store — see the merge in containers/Leads/reducers.js.
  return {
    lead: {
      id,
      organizationId: orgId,
      leadCustomStatusId,
      status,
      lostReason: lostReasonId,
      dateInquiry,
      venueName,
      contactFirstName,
      contactLastName,
      contactCompanyName,
      contactId,
      party,
      weddingDate: eventDate,
      estimatedBudget: estimateBudget,
      projectName,
      createdAt,
      lastContactedDate,
      isDeleted,
      organizationLeadContactId: orgLeadContactId,
      isSavedLead: true,
      allDay,
      startTime,
      endTime,
      customStatus: {
        id: leadCustomStatusId,
        orgId,
      },
    },
  };
};
